export default {
    approval_info: {
        zhCN: {
            approval_no: '审批号',
            approval_type: '审批类型',
            approval_record_id: '审批记录ID',
        },
        enUS: {
            approval_no: 'Approval No.',
            approval_type: 'Approval Type',
            approval_record_id: 'Approval Record ID',
        },
    },
}
